import { IBadgeHeader } from './types';
import { Grid, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styles } from './styles';

export const BadgeHeader = ({ heading, actionText, onActionClick }: IBadgeHeader) => {
  return (
    <Grid sx={styles.container}>
      <Grid sx={styles.headingWrapper}>
        <Typography sx={styles.heading}>{heading}</Typography>
      </Grid>
      <Grid sx={styles.actionContainer}>
        <Typography onClick={onActionClick} sx={styles.action}>
          {actionText}
        </Typography>
        <ChevronRightIcon sx={styles.chevronIcon} />
      </Grid>
    </Grid>
  );
};
